// ─────────────────────────────────────────────────────────────────────────────
// Price Observations Selectors
// ─────────────────────────────────────────────────────────────────────────────
// NgRx selectors for the priceObservations store slice.
// ─────────────────────────────────────────────────────────────────────────────

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PriceObservationsState } from './price-observations.reducers';

// ── Feature selector ─────────────────────────────────────────────────────────

export const selectPriceObservations = createFeatureSelector<PriceObservationsState>('priceObservations');

// ── Basic selectors ──────────────────────────────────────────────────────────

export const selectPriceObservationItems = createSelector(selectPriceObservations, (state) => state.observations);
export const selectPriceObservationMetadata = createSelector(selectPriceObservations, (state) => state.metadata);
export const selectPriceObservationLoading = createSelector(selectPriceObservations, (state) => state.loading);

// ── Import journal ───────────────────────────────────────────────────────────

export const selectPriceImportItems = createSelector(selectPriceObservations, (state) => state.imports);
export const selectPriceImportMetadata = createSelector(selectPriceObservations, (state) => state.importsMetadata);

// ── Review counters ──────────────────────────────────────────────────────────
// What the tab header shows. There is no pushed notification: a count on the
// tab is what an operator comes back to.

export const selectPriceObservationUnresolvedCount = createSelector(selectPriceObservations, (state) => state.unresolvedCount);
export const selectPriceObservationToVerifyCount = createSelector(selectPriceObservations, (state) => state.toVerifyCount);
export const selectPriceObservationConflictCount = createSelector(selectPriceObservations, (state) => state.conflictCount);
